/* ════════════════════════════════════════════════════
 *  <kik-how-it-works> — drives the determinate progress bar.
 *
 *  The carousel itself is a child <kik-swiper> (Swiper), enabled only below
 *  750px; at ≥750 Swiper is disabled and the steps render as a static row. This
 *  wrapper binds to that instance and grows a left-anchored fill in LENGTH as
 *  the carousel advances — (activeIndex + 1) / slides → full at the last slide.
 *  Swiper's own progressbar is window-proportional (never reaches full), so the
 *  fill is driven here instead. Pure progressive enhancement.
 * ════════════════════════════════════════════════════ */

if (!customElements.get('kik-how-it-works')) {
  class KikHowItWorks extends HTMLElement {
    connectedCallback() {
      this.fill = this.querySelector('.section-kik-how-it-works__progress-fill');
      this.host = this.querySelector('kik-swiper');
      if (!this.fill || !this.host) return;
      this.update = this.update.bind(this);
      this.bind();
    }

    disconnectedCallback() {
      this.swiper?.off('slideChange', this.update);
      this.swiper?.off('resize', this.update);
    }

    /* <kik-swiper> builds its Swiper in its own connectedCallback, which can run
       after this one — retry on the next frame until the instance exists. */
    bind(attempt = 0) {
      if (!this.isConnected) return;
      const swiper = this.host.swiper;
      if (!swiper) {
        if (attempt < 30) requestAnimationFrame(() => this.bind(attempt + 1));
        return;
      }
      this.swiper = swiper;
      swiper.on('slideChange', this.update);
      swiper.on('resize', this.update);
      this.update();
    }

    update() {
      const swiper = this.swiper;
      if (!swiper) return;
      const total = swiper.slides.length;
      const pct = swiper.isEnd ? 100 : ((swiper.activeIndex + 1) / total) * 100;
      this.fill.style.inlineSize = `${pct}%`;
    }
  }

  customElements.define('kik-how-it-works', KikHowItWorks);
}
